<template>
	<div class="form-field">
		<label :for="inputId">{{ sanitizeContent(field.fields.fieldName) }}</label>
		<input :id="inputId" :name="removeDiacritics(field.fields.fieldName).toLowerCase()" value="" :type="sanitizeContent(field.fields.fieldType)" />

		<div class="error-message">{{ sanitizeContent(field.fields.fieldErrorMessage) }}</div>
<!--		<p v-if="nameError" class="text-red-500 text-sm">error</p>-->
	</div>
</template>
<script setup>
import {useSanitize} from "~~/composables/useSanitize.js";
import { removeDiacritics } from '~/utils/removeDiacritics.js';

const { sanitizeContent } = useSanitize();

const props = defineProps({
	content: {
		type: Object,
		required: true
	}
});

const field = computed(() => props?.content ?? {});
</script>